import React from "react";
import { useTranslation } from "react-i18next";
import { formatDateToTime } from "../../helpers/function";
import appConfig from "../../config/appConfig";

const IncompleteClaimHistoryDrawer = ({ claim, show, onClose, onOpenFollowUpModal }) => {
  const { t, ready } = useTranslation();

  if (!ready || !show || !claim) return null;

  const followUps = claim.claimer_follow_ups || claim.claimerFollowUps || [];
  const sortedFollowUps = [...followUps].sort((a, b) => {
    const dateA = new Date(a.created_at || a.follow_up_date || 0);
    const dateB = new Date(b.created_at || b.follow_up_date || 0);
    return dateB - dateA;
  });

  return (
    <>
      <div
        className="kt-offcanvas-panel-overlay"
        style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.45)", zIndex: 1050
        }}
        onClick={onClose}
      />
      <div
        className="kt-offcanvas-panel kt-offcanvas-panel--on"
        style={{
          position: "fixed", top: 0, right: 0, width: "450px", maxWidth: "90vw",
          height: "100vh", zIndex: 1051, backgroundColor: "#ffffff",
          boxShadow: "-5px 0 25px rgba(82, 63, 105, 0.15)",
          display: "flex", flexDirection: "column", overflow: "hidden"
        }}
      >
        <div
          className="kt-offcanvas-panel__head"
          style={{
            padding: "1.25rem 1.5rem", borderBottom: "1px solid #ebedf2",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            backgroundColor: "#f7f8fa"
          }}
        >
          <div>
            <h5 className="kt-offcanvas-panel__title m-0 font-weight-bold text-dark">
              <i className="la la-history text-info mr-2" style={{ fontSize: "1.4rem" }} />
              {t("Historique & Relances")}
            </h5>
            <small className="text-muted font-weight-bold">
              {t("Réclamation")} #{claim.reference || "-"}
            </small>
          </div>
          <button
            type="button"
            className="btn btn-sm btn-clean btn-icon"
            onClick={onClose}
            title={t("Fermer")}
            style={{ borderRadius: "50%" }}
          >
            <i className="la la-close font-weight-bold" style={{ fontSize: "1.3rem" }} />
          </button>
        </div>

        <div className="kt-offcanvas-panel__body" style={{ padding: "1.25rem 1.5rem", overflowY: "auto", flex: 1 }}>
          <div className="card card-custom bg-light mb-4 border-0 shadow-sm">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="font-weight-bold text-muted small">{t("Réclamant")} :</span>
                <span className="text-dark font-weight-bold">
                  {claim.claimer?.raison_sociale
                    ? claim.claimer.raison_sociale
                    : `${claim.claimer?.lastname || ""} ${claim.claimer?.firstname || ""}`}
                </span>
              </div>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="font-weight-bold text-muted small">{t("Objet")} :</span>
                <span className="text-dark font-weight-bold">
                  {claim.claim_object?.name?.fr || claim.claim_object?.name || "-"}
                </span>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span className="font-weight-bold text-muted small">{t("Total relances")} :</span>
                <span className="badge badge-warning font-weight-bold">{sortedFollowUps.length}</span>
              </div>
            </div>
          </div>

          <h6 className="font-weight-bold text-dark mb-3">
            <i className="flaticon-time-1 text-primary mr-2" />
            {t("Fil des relances et actions")}
          </h6>

          <div className="follow-ups-history-container">
            {sortedFollowUps.length > 0 ? (
              sortedFollowUps.map((item, idx) => {
                const staffName = item.staff
                  ? `${item.staff.firstname || ""} ${item.staff.lastname || ""}`.trim() || item.staff.identite?.firstname || "-"
                  : "-";

                return (
                  <div className="card mb-3 border-left-warning shadow-sm" key={item.id || idx}>
                    <div className="card-header bg-white py-2 px-3 d-flex align-items-center justify-content-between">
                      <span className="badge badge-warning font-weight-bold">
                        <i className="la la-paper-plane mr-1" />
                        {t("Relance #")}{sortedFollowUps.length - idx}
                      </span>
                      <small className="text-muted font-weight-bold">
                        {formatDateToTime(item.follow_up_date || item.created_at)}
                      </small>
                    </div>
                    <div className="card-body p-3">
                      {item.message && <p className="text-dark mb-2" style={{ whiteSpace: "pre-wrap" }}>{item.message}</p>}
                      <div className="d-flex align-items-center text-muted small mt-2">
                        <i className="la la-user mr-1 text-primary" />
                        <span>{t("Effectuée par")} : <strong className="text-dark">{staffName}</strong></span>
                      </div>

                      {item.files && item.files.length > 0 && (
                        <div className="mt-3 pt-2 border-top">
                          <span className="font-weight-bold small text-dark d-block mb-1">
                            <i className="la la-paperclip mr-1 text-primary" />{t("Pièces jointes")} :
                          </span>
                          <div className="d-flex flex-wrap">
                            {item.files.map((file, fIdx) => (
                              <a
                                key={file.id || fIdx}
                                href={file.url?.startsWith("http") ? file.url : `${appConfig.apiDomaine}${file.url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-xs btn-outline-primary mr-1 mb-1"
                              >
                                <i className="flaticon2-file mr-1" />
                                {file.title || file.name || `${t("Fichier")} #${fIdx + 1}`}
                              </a>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="alert alert-light text-center py-4 text-muted mb-3">
                <i className="la la-info-circle display-4 d-block mb-2 text-muted" />
                {t("Aucune relance enregistrée pour cette réclamation.")}
              </div>
            )}

            <div className="card mb-3 border-left-info shadow-sm">
              <div className="card-header bg-white py-2 px-3 d-flex align-items-center justify-content-between">
                <span className="badge badge-info font-weight-bold">
                  <i className="la la-plus-circle mr-1" />{t("Création / Réception")}
                </span>
                <small className="text-muted font-weight-bold">
                  {formatDateToTime(claim.received_at || claim.created_at)}
                </small>
              </div>
              <div className="card-body p-3">
                <p className="text-dark mb-0 small">
                  {t("Enregistrement initial avec le statut ")}
                  <strong className="text-warning">{t("Incomplète")}</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>

        {onOpenFollowUpModal && (
          <div className="kt-offcanvas-panel__footer" style={{ padding: "1rem 1.5rem", borderTop: "1px solid #ebedf2", backgroundColor: "#f7f8fa" }}>
            <button
              type="button"
              className="btn btn-primary btn-block font-weight-bold"
              onClick={() => {
                onClose();
                onOpenFollowUpModal(claim);
              }}
            >
              <i className="la la-paper-plane mr-2" />{t("Effectuer une nouvelle relance")}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default IncompleteClaimHistoryDrawer;
